module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/rosanjin-5f47499a4fb4628910a75bb474cb0559.jpg";